<template lang="pug">
  .table-responsive
    table#tbTraspasos.table.is-striped.is-fullwidth.is-narrow(v-show="hayDatos")
      thead
        tr
          th
            | #
          th 
            | Fecha Reg.
          th 
            | Usuario
          th 
            | Tarjeta Entrega
          th 
            | Tarjeta Recibe
          th 
            | Cantidad
      tbody
        tr(v-for="(trasp, index) in traspasos" :key="trasp.id")
          td
            a.button.is-black.is-rounded.is-small(@click="eliminarTraspaso(trasp)")
              i.fas.fa-trash
          td
            | {{ trasp.fechaReg }}
          td 
            | {{ trasp.entrega }}
          td 
            | {{ trasp.no_tarjeta_e }}
          td 
            | {{ trasp.no_tarjeta_r }}
          td
            | {{ trasp.cantidad | currency }}
    .notification(v-show="!hayDatos")
      strong  No registros para esta búsqueda.
</template>

<script>
import InventarioServices from '../../../services/inventario/inventario'
  export default {
    name: 'Tb_Traspasos',
    props: {
      traspasos: {
        type: Array,
        default: () => []
      },
      traspasoSel: {
        type: Object,
        default () {
          return {
            vacio: true
          }
        }
      }
    },
    data() {
      return {
        hayDatos: false,
        itemsSelected: {},
        isDisabled: true
      }
    },
    watch: {
      traspasos() {
        this.checkDatos()  
      },
      disabledItems() {
        this.isDisabled = this.disabledItems
      },
      itemsSelected () {
        this.$emit('seleccionarItem', this.itemsSelected)
      },
      reset () {
        console.log(`Reset: ${this.reset}`)
        if (this.reset) {
          this.itemsSelected = {}
        }
      },
      traspasoSel () {
        this.itemsSelected = Object.assign({}, this.itemsSelected, this.traspasoSel)
      }
      
    },
    methods: {
      iniciarComponente () {
        console.log(this.traspasoSel)
        this.checkDatos()
      },
      
      checkDatos () {
        if (this.traspasos.length > 0) {
          this.hayDatos = true
        } else {
          this.hayDatos = false
        }
      },

      eliminarTraspaso(traspaso) {
        this.$emit('eliminarTraspaso', traspaso)
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/Tb_Traspasos.vue